<template>
    <div>
        <kgr-month-picker
            :max-month="maxMonth"
            :inline="true"
            class="kgr-row"
            :max-year="maxYear"
            @change="onMonthSelected($event)"
        />

        <kgr-child-moods-data-provider
            v-if="selectedMonth"
            :child-id="childId"
            :month="selectedMonth.month"
            :year="selectedMonth.year"
        >
            <template #default="{ data }">
                <table class="kgr-table kgr-table--striped kgr-table--block table-groups">
                    <thead>
                        <tr class="kgr-table__row">
                            <th class="kgr-table__cell kgr-table__cell--headline date">
                                {{ $t('Datum') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Allg. Befindlichkeit') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Essverhalten') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Schlafverhalten') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Stuhlgang') }}
                            </th>
                            <th class="kgr-table__cell kgr-table__cell--headline">
                                {{ $t('Bemerkung') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="mood of filterMoodData(data)"
                            :id="'row' + mood.date.format('YMMDD')"
                            :key="'row' + mood.date.format('YMMDD')"
                            class="table-row"
                            :class="{'today': mood.date.format('YYYYMMDD') === now.format('YYYYMMDD')}"
                        >
                            <td class="mood-date">
                                {{ moment(mood.date).format('DD.MM.YYYY') }}
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-mood-picker
                                    v-model="mood.generalMood"
                                    edit-mode
                                    @changed="updateMood(mood)"
                                />
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-mood-picker
                                    v-model="mood.eatingBehaviour"
                                    edit-mode
                                    @changed="updateMood(mood)"
                                />
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-mood-picker
                                    v-model="mood.sleepingBehaviour"
                                    edit-mode
                                    @changed="updateMood(mood)"
                                />
                            </td>
                            <td class="kgr-table__cell">
                                <kgr-mood-picker
                                    v-model="mood.bowelMovement"
                                    edit-mode
                                    @changed="updateMood(mood)"
                                />
                            </td>
                            <td class="kgr-table__cell">
                                <a
                                    v-if="!mood.comment && newCommentMood !== mood"
                                    @click="newCommentFor(mood)"
                                >
                                    {{ $t('add') }}
                                </a>
                                <textarea
                                    v-else
                                    :ref="'comment'+mood.date.format('YMMDD')"
                                    v-model="mood.comment"
                                    class="kgr-input"
                                    @change="updateMood(mood)"
                                >
                            </textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </kgr-child-moods-data-provider>
    </div>
</template>

<script>
import ChildMoodRepository from '../../../js/repository/ChildMoodRepository';
import ChildMoodsDataProvider from '../../data-provider/ChildMoodsDataProvider.vue';
import MonthPicker from '../../common/form/picker/MonthPicker.vue';
import MoodPicker from './MoodPicker.vue';

export default {
    components: {
        'kgr-month-picker': MonthPicker,
        'kgr-mood-picker': MoodPicker,
        'kgr-child-moods-data-provider': ChildMoodsDataProvider,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            loading: true,
            selectedMonth: null,
            newCommentMood: null,
            now: this.moment(),
        }
    },
    computed: {
        maxMonth() {
            return +this.now.format('M');
        },
        maxYear() {
            return +this.now.format('Y');
        }
    },
    methods: {
        filterMoodData(data) {
            return data.filter(mood => mood.date <= this.now);
        },
        onMonthSelected(selection) {
            this.selectedMonth = null;
            this.$nextTick(() => this.selectedMonth = selection);
        },
        updateMood(mood) {
            ChildMoodRepository.update(this.childId, mood)
                .then(() => this.highlightRow(mood))
                .catch(() => this.$notify.error('saveChanges.error'));
        },
        newCommentFor(mood) {
            this.newCommentMood = mood;
            this.$nextTick(() => this.$refs['comment' + mood.date.format('YMMDD')][0].focus());
        },
        highlightRow(mood) {
            $('#row' + mood.date.format('YYYYMMDD')).find('td').effect('highlight');
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    a {
        color: #0071AD;
        text-decoration: underline;
        cursor: pointer;
    }

    th {
        &.date {
            width: 65px;
        }
    }

    td {
        text-align: center;
    }

    tr:hover {
        & td {
            background-color: #cde9fb;
        }
    }

    tr {
        &.today > td {
            border-bottom: 1px solid #000000;
            &.mood-date {
                font-weight: var(--kgr-font-weight-bold);
            }
        }
    }
</style>
